import { Loader2, Users } from "lucide-react";
import { useState } from "react";
import { useLocation } from "wouter";

import { ProfileForm, CompanyForm } from "./ui";

import { useGetUserProfile } from "@/common/api";
import { ChangePasswordDialog } from "@/common/components";
import { Tabs, TabsContent } from "@/common/components";
import { ROUTES } from "@/common/config";
import { useAuth, useUser } from "@/common/hooks";
import { useToast } from "@/common/hooks";

export function ProfilePage() {
  const {
    auth: { id },
  } = useAuth();
  const { toast } = useToast();
  const [, setLocation] = useLocation();
  const { permissions } = useUser();
  const { data, isLoading } = useGetUserProfile({
    userId: id!,
  });

  const userInfo = data?.data.payload?.userInfo;
  const companyInfo = data?.data.payload?.companyInfo;

  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);

  const handleSubmit = () => {
    toast({
      title: "Запрос отправлен",
      description: "Изменения профиля отправлены на модерацию",
    });
  };

  const handleCancel = () => {
    setLocation(ROUTES.ROOT);
  };

  const handleClose = () => {
    setIsPasswordDialogOpen(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-4xl py-6">
      <div className="mb-6 flex md:flex-row flex-col justify-between items-start gap-4">
        <div>
          <h1 className="md:text-2xl text-xl md:font-semibold font-bold md:leading-7 leading-6 text-gray-900 dark:text-white flex items-center gap-2">
            <Users className="md:h-6 h-4 md:w-6 w-4" />
            Профиль пользователя
          </h1>
          <p className="text-base font-normal leading-5 text-gray-600 dark:text-gray-400 mt-2">
            Управление профилем и настройками
          </p>
        </div>

        {/* Кнопка смены пароля */}
        {permissions?.profile.change_password && (
          <ChangePasswordDialog
            isOpen={isPasswordDialogOpen}
            setIsOpen={setIsPasswordDialogOpen}
            hasButton
            withCurrentPassword
            onSave={handleClose}
            onClose={handleClose}
          />
        )}
      </div>

      <Tabs defaultValue="profile" className="w-full">
        {/* <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="profile" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            Профиль компании
          </TabsTrigger>
          <TabsTrigger value="notifications" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Настройки уведомлений
          </TabsTrigger>
        </TabsList> */}

        <TabsContent value="profile" className="mt-6">
          {userInfo && (
            <ProfileForm
              isPending={false}
              data={userInfo}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
            />
          )}

          {companyInfo && (
            <CompanyForm
              isPending={false}
              data={companyInfo}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
            />
          )}
        </TabsContent>

        {/* <TabsContent value="notifications" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Settings className="h-5 w-5" />
                Настройки уведомлений
              </CardTitle>
            </CardHeader>
            <CardContent>
              <NotificationSettingsPage />
            </CardContent>
          </Card>
        </TabsContent> */}
      </Tabs>
    </div>
  );
}
